import { GetSourceFromUrlProps, GetSourceFromUrlResult, getUrlProps } from './';

export function getSourceFromUrl(
  props: GetSourceFromUrlProps,
): GetSourceFromUrlResult {
  const { url } = props;

  if (!url)
    return {
      ...url,
      urlDestination: 'void',
    };

  if (url.internalLink) {
    return {
      ...url,
      urlDestination: 'contentful',
      url: getUrlProps(url.internalLink).path,
    };
  } else if (url.externalLink) {
    return {
      ...url,
      urlDestination: 'external',
      url: url.externalLink,
    };
  }

  return {
    ...url,
    urlDestination: 'void',
  };
}
